// utils/file.ts
import { AxiosResponse } from 'axios';
import { saveAs } from 'file-saver';

export const handleSaveFile = (response: AxiosResponse) => {
    try {
    // Lấy tên file từ header
        const contentDisposition = response.headers?.['content-disposition'] || '';
        const filename = decodeURIComponent(
            contentDisposition.split('filename*=')[1]?.split('\'\'')[1] ||
            contentDisposition.split('filename=')[1]?.split(';')[0]?.replace(/"/g, '') ||
            'download'
        );

        // Tạo Blob
        const blob = new Blob([response.data], {
            type: response.headers?.['content-type'] || 'application/octet-stream'
        });

        // Xử lý đặc biệt cho Safari iOS
        if (/iPad|iPhone|iPod|Macintosh/i.test(navigator.userAgent)) {
            return handleIOSDownload(blob, filename);
        }

        // Các trình duyệt khác
        saveAs(blob, filename);
    } catch (error) {
        console.error('Download failed:', error);
        throw new Error('File download error');
    }
};

// Xử lý download cho iOS
const handleIOSDownload = (blob: Blob, filename: string) => {
    return new Promise((resolve, reject) => {
    // Tạo iframe ẩn
        const iframe = document.createElement('iframe');
        iframe.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;';

        // Tạo blob URL và gán vào iframe
        const blobURL = URL.createObjectURL(blob);
        iframe.src = blobURL;

        // Thêm sự kiện load
        iframe.onload = () => {
            try {
                // Tạo link ẩn trong iframe
                const doc = iframe.contentDocument!;
                const link = doc.createElement('a');
                link.href = blobURL;
                link.download = filename;
                doc.body.appendChild(link);

                // Kích hoạt click
                const event = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true
                });
                link.dispatchEvent(event);

                // Cleanup
                setTimeout(() => {
                    doc.body.removeChild(link);
                    URL.revokeObjectURL(blobURL);
                    document.body.removeChild(iframe);
                }, 5000);

                resolve(true);
            } catch (e) {
                reject(e);
            }
        };

        document.body.appendChild(iframe);
    });
};
